

  $(document).ready(function(){
    $(".mobile_menu > .h6").click(function(){
      $(this).next().toggleClass('active');
    });


    


var swiper = new Swiper(".mySwiper-review", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    centeredSlides: !0,
  direction: 'horizontal',
    loop: !1,
    pagination: { el: ".swiper-pagination-review", clickable: !0 },
    navigation: { nextEl: ".swiper-button-next-review", prevEl: ".swiper-button-prev-review" },
    breakpoints: { 
      768: { slidesPerView: 3, spaceBetween: 20, centeredSlides: !1 }, 
      1024: { slidesPerView: 4, spaceBetween: 20, centeredSlides: !1 } },
});


  
});







